export default __webpack_public_path__ + "static/media/404.635df316.gif";